import { TreeSelect } from 'antd';
import { useEffect, useState } from 'react';
import { hMacAjax as fetch } from 'grt-tool-lib-front';
import { listToTree } from '@/store/utils';
import './index.less';
import { baseURL } from '@/httpService/API';
let improveOrgList = `${baseURL}/grt-user-center-service/open/org`;
// data_source_type 1自定义  2平台数据源
const TreeSelectForm = (props) => {
    let { setting = {}, updated, desc } = props;
    const disabled = updated !== 0,
    //当前下拉树只有组织树(预置字段),先前端写死处理
     [treeData, setTreeData] = useState([]),
     [defaultExpandedKeys, setDefaultExpandedKeys] = useState([]);
    let getTreeData = () => {
        fetch.get(improveOrgList).then((res) => {
            if (res.success) {
                let formatTree = listToTree(res.data || []),
                 defaultId = formatTree[0] && formatTree[0].id;
                setDefaultExpandedKeys((defaultId && [defaultId]) || []);
                setTreeData(formatTree);
            }
        });
    };
    useEffect(() => {
        if (setting.data_source_type && setting.data_source_type === 1) {
            setTreeData(setting.options);
        } else {
            getTreeData();
        }
    }, []);
    return (
        <TreeSelect
            popupClassName={'grt-tree-select'}
            disabled={disabled}
            showSearch
            treeDefaultExpandedKeys={defaultExpandedKeys}
            treeNodeFilterProp={'org_name'}
            fieldNames={{ label: 'org_name', value: 'id' }}
            dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
            placeholder={desc}
            allowClear
            treeData={treeData}
            virtual={false}
        />
    );
    // return <Select fieldNames={{ label: 'name', value: 'id' }} placeholder="请选择" options={options} />;
};
export default TreeSelectForm;
